import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from 'react';

interface FreeTrialFormContextData {
  isSubmitted: boolean;
  markAsSubmitted(): void;
}

const FreeTrialFormContext = createContext<FreeTrialFormContextData>({} as FreeTrialFormContextData);

const FreeTrialFormProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const markAsSubmitted = useCallback(() => {
    setIsSubmitted(true);
  }, []);

  return (
    <FreeTrialFormContext.Provider
      value={{
        isSubmitted,
        markAsSubmitted,
      }}
    >
      {children}
    </FreeTrialFormContext.Provider>
  );
};

const useFreeTrialFormContext = (): FreeTrialFormContextData => {
  const context = useContext(FreeTrialFormContext);

  if (!context) {
    throw new Error('useFreeTrialFormContext must be used within a FreeTrialFormProvider');
  }

  return context;
};

export { useFreeTrialFormContext, FreeTrialFormProvider };
